import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var ServiceService = /** @class */ (function () {
    function ServiceService(http) {
        this.http = http;
    }
    ServiceService.prototype.get_orphan_home_list = function (param) {
        return this.http.get("http://orphanhome.herokuapp.com/orphanhome/homelist?name=" + param);
    };
    ServiceService.prototype.post_orphan_home_list = function (data) {
        return this.http.post("http://orphanhome.herokuapp.com/orphanhome/homelist", data);
    };
    ServiceService.prototype.post_voluntaries_list = function (data) {
        return this.http.post("http://orphanhome.herokuapp.com/voluntaries/newvoluntaries", data);
    };
    ServiceService.prototype.get_voluntaries_list = function () {
        return this.http.get("http://orphanhome.herokuapp.com/voluntaries/newvoluntaries");
    };
    ServiceService.prototype.post_new_donor = function (data) {
        return this.http.post("http://orphanhome.herokuapp.com/donation/newdonor", data);
    };
    ServiceService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    ServiceService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], ServiceService);
    return ServiceService;
}());
export { ServiceService };
//# sourceMappingURL=service.service.js.map